import { DataManager } from '../../core/data-manager';
import { LoginManager } from '../../core/login-manager';
import Swal from 'sweetalert2';



export async function preDelete(entity, id) {

    const userInfo = LoginManager.getUserInfo();

    if (entity === "customer_order") {
        // Admin (level 0) can delete without restrictions
        if (userInfo && userInfo.level === 0) {
            return {
                success: 1,
                message: ''
            };
        }
        let constraints = [{ "fieldName": "idCustomerOrder", type: "value", value: id }]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.searchItems('supplier_order', 1, 100, sorting, '', [], constraints)
        if (res.success === 1) {
            if (res.body.length > 0) {
                Swal.fire({ title: 'Errore', text: 'Attenzione! Non è possibile cancellare questo ordine perché sono già stati creati gli ordini fornitore.', icon: 'error', confirmButtonColor: '#dc3545' })
                return { success: 0, message: 'Ordini fornitore esistenti' }
            } else {
                return {
                    success: 1,
                    message: ''
                }
            }
        }
    } else if (entity === "customer") {
        // Admin (level 0) can delete without restrictions
        if (userInfo && userInfo.level === 0) {
            return {
                success: 1,
                message: ''
            };
        }
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: id }]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var resOrder = await DataManager.searchItems('customer_order', 1, 100, sorting, '', [], constraints)
        var resOffer = await DataManager.searchItems('customer_offer', 1, 100, sorting, '', [], constraints)
        if (resOrder.success === 1 && resOffer.success === 1) {
            if (resOffer.body.length > 0 || resOrder.body.length > 0) {
                Swal.fire({ title: 'Errore', text: 'Attenzione! Non è possibile cancellare questo cliente perché sono già stati creati preventivi o ordini.', icon: 'error', confirmButtonColor: '#dc3545' })
                return { success: 0, message: 'Preventivi o ordini esistenti' }
            } else {
                return {
                    success: 1,
                    message: ''
                }
            }
        }
    }
    else if (entity === 'customer_order_delivery') {
        // Admin (level 0) can delete without restrictions
        if (userInfo && userInfo.level === 0) {
            return {
                success: 1,
                message: ''
            };
        }

        try {
            const deliveryResponse = await DataManager.getItem('customer_order_delivery', id);
            if (deliveryResponse.success !== 1 || !deliveryResponse.body || deliveryResponse.body.length === 0) {
                throw new Error(deliveryResponse.message || 'Impossibile recuperare i dettagli della consegna.');
            }

            const delivery = deliveryResponse.body[0];
            const statusValue = typeof delivery.status === 'string' ? delivery.status : delivery.status?.value;
            if (statusValue === '20_DELIVERED') {
                Swal.fire({ title: 'Errore', text: 'Non è possibile cancellare una consegna già consegnata.', icon: 'error', confirmButtonColor: '#dc3545' })
                return {
                    success: 0,
                    message: 'Consegna già consegnata'
                };
            }

            const deliveryRows = Array.isArray(delivery.rows) ? delivery.rows : [];

            const customerOrderRowIds = Array.from(new Set(deliveryRows
                .map((row) => {
                    if (!row) {
                        return null;
                    }
                    if (row.idCustomerOrderRow && typeof row.idCustomerOrderRow === 'object') {
                        return row.idCustomerOrderRow.id;
                    }
                    return row.idCustomerOrderRow;
                })
                .filter((value) => value !== null && value !== undefined)
            ));

            if (!customerOrderRowIds.length) {
                Swal.fire({ title: 'Completato', text: 'Consegna eliminata con successo.', icon: 'success', confirmButtonColor: '#198754' })
                return {
                    success: 1,
                    message: ''
                };
            }

            const updatePromises = customerOrderRowIds.map((rowId) =>
                DataManager.updateItem('customer_order_row', { status: { value: '10_RECEIVED', label: '10_RECEIVED' } }, rowId)
            );

            const updateResponses = await Promise.all(updatePromises);
            const hasFailure = updateResponses.some((res) => !res || res.success !== 1);
            if (hasFailure) {
                throw new Error('Impossibile aggiornare lo stato delle righe ordine cliente collegate.');
            }

            Swal.fire({ title: 'Completato', text: 'Consegna eliminata con successo.', icon: 'success', confirmButtonColor: '#198754' })

            return {
                success: 1,
                message: ''
            };
        }
        catch (error) {
            console.error('Errore durante la verifica eliminazione consegna:', error);
            Swal.fire({ title: 'Errore', text: error.message || 'Impossibile ripristinare lo stato delle righe ordine cliente.', icon: 'error', confirmButtonColor: '#dc3545' })
            return {
                success: 0,
                message: error.message || 'Errore durante la preparazione della cancellazione.'
            };
        }
    }
    else {
        return {
            success: 1,
            message: ''
        }
    }




}
